import { RelevanceOptions } from '@/constants/filterOptions';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/new/components/shadcn/select';
import { Relevance } from '@/types';

export function RelevanceSelector({
  relevanceText,
  updateRelevance,
}: {
  relevanceText: Relevance;
  updateRelevance: (relevance: Relevance) => void;
}) {
  return (
    <Select value={relevanceText} onValueChange={updateRelevance}>
      <SelectTrigger className="h-auto bg-white px-2.5 py-1.5 text-xs">
        <SelectValue placeholder="Select Relevance" />
      </SelectTrigger>
      <SelectContent>
        {Object.values(RelevanceOptions).map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
